import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainValidation() {
  const painPoints = ['Sleeves that bunch at your wrists', 'Inseams that drag on the ground', 'Waistlines that hit in the wrong place', 'Tailoring bills that add up fast'];
  return <section className="py-20 bg-card" data-id="element-111">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-114">
            Shopping Shouldn't Feel This Hard
          </h2>
          <p className="text-lg text-text-muted" data-id="element-115">
            You're tired of the compromise. We get it.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-116">
          <div className="space-y-6" data-id="element-117">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-center space-x-4 p-4 rounded-lg bg-primary border border-border" data-id="element-118">
                <XCircle className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-119" />
                <span className="text-lg text-white" data-id="element-120">{point}</span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gradient-to-br from-accent/20 to-accent/5 p-8 md:p-12 rounded-2xl text-center flex flex-col justify-center h-full border border-accent/20" data-id="element-121">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-122">The Truth?</h3>
            <p className="text-xl md:text-2xl font-serif italic text-accent mb-2" data-id="element-123">
              "It's not your body."
            </p>
            <p className="text-lg text-white" data-id="element-124">It's how clothes are made.</p>
          </motion.div>
        </div>
      </div>
    </section>;
}